import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export const DeleteCompanyDialog = ({ company, onClose, onDeleted }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const match = !!company && name.trim().toLowerCase() === company.name.trim().toLowerCase();
  const close = () => { if (!busy) { setName(""); onClose(); } };
  const del = async () => {
    setBusy(true);
    try {
      await api.ownerDeleteCompany(company.id, name);
      toast.success(`${company.name} deleted`);
      setName(""); onDeleted(company.id);
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not delete the company"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!company} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="owner-delete-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-destructive">Delete {company?.name}?</DialogTitle>
          <DialogDescription>
            This permanently removes the company, its depots, logins, crew list, clients, jobs, rosters, timesheets, payroll and photos.
            Workers&apos; own accounts stay (they may work for other companies). This can&apos;t be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="del-name">Type <span className="font-semibold">{company?.name}</span> to confirm</Label>
          <Input id="del-name" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" data-testid="owner-delete-confirm-input" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={close} disabled={busy} className="rounded-full">Cancel</Button>
          <Button onClick={del} disabled={!match || busy} className="rounded-full bg-destructive hover:bg-destructive/90 text-white" data-testid="owner-delete-confirm-btn">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Trash2 className="w-4 h-4 mr-2" />} Delete forever
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
